import { CurrencyApi } from '@/api/CurrencyApi';

export async function prefetchCurrencySilently() {
    CurrencyApi.fetchAll()
}